module.exports = __webpack_public_path__ + "static/media/check-mark.1f9d033b.svg";